import { createFileRoute, getRouteApi, Navigate } from "@tanstack/react-router";

const companyRoute = getRouteApi("/firmen/$companyId");

export const Route = createFileRoute("/firmen/$companyId/")({
  component: CompanyIndexRoute,
});

function CompanyIndexRoute() {
  const { companyId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();
  return (
    <Navigate
      to="/firmen/$companyId/aufgaben"
      params={{ companyId }}
      search={jahr !== undefined ? { jahr } : {}}
      replace
    />
  );
}
